export default __webpack_public_path__ + "static/media/success-Sound.fe21b875.mp3";